<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ประวัติ Web Stamp</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ดูประวัติการ stamp ตามลานที่เลือก — กดดูรายละเอียดเมื่อหมายเหตุยาว
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div
        class="flex items-center gap-2 px-3 py-2 bg-white/95 dark:bg-slate-800/95 rounded-2xl border border-slate-100/50 dark:border-slate-700/50 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto">
        <span class="material-icons text-slate-400 dark:text-slate-500 text-xl">calendar_today</span>
        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate"
            (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
        <span class="text-slate-300 dark:text-slate-600">-</span>
        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
            (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
      </div>

      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right w-[112px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">history</span>
        รายการ stamp
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
        <span *ngIf="totalItems() > 0"
          class="text-[11px] font-bold text-slate-400 bg-slate-100 dark:bg-slate-900 px-2 py-1 rounded-lg">
          {{ totalItems() | number }} รายการ
        </span>
      </h3>

      <div class="flex flex-col md:flex-row gap-3 w-full xl:flex-1 xl:min-w-0 xl:justify-end">
        <div
          class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-visible w-full md:flex-1 md:min-w-[360px] relative z-30 h-[46px]">
          <div class="relative min-w-[140px] shrink-0 border-r border-slate-200 dark:border-slate-700 h-full">
            <button type="button" (click)="toggleSearchTypeDropdown()"
              class="w-full pl-4 pr-3 h-full text-xs font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-850 rounded-l-xl transition-all focus:outline-none border-none bg-transparent cursor-pointer">
              <span>{{ currentSearchTypeLabel }}</span>
              <span class="material-icons text-xs text-slate-400 transition-transform duration-200"
                [class.rotate-180]="isSearchTypeDropdownOpen">expand_more</span>
            </button>
            <button *ngIf="isSearchTypeDropdownOpen" type="button"
              class="fixed inset-0 cursor-default z-40 border-none bg-transparent"
              (click)="toggleSearchTypeDropdown()"></button>
            <div *ngIf="isSearchTypeDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full mt-2 left-0 w-[200px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden">
              <button *ngFor="let opt of searchTypeOptions" type="button" (click)="selectSearchType(opt.value)"
                class="w-full text-left px-4 py-2.5 text-xs font-medium text-slate-650 dark:text-slate-350 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-base text-slate-400">{{ opt.icon }}</span>
                {{ opt.label }}
              </button>
            </div>
          </div>
          <div class="relative flex-1 h-full">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-xl">search</span>
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearchSubmit()"
              placeholder="พิมพ์คำค้นแล้วกด Enter..."
              class="w-full pl-10 pr-4 h-full bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600">
          </div>
          <button type="button" (click)="onSearchSubmit()"
            class="px-4 h-full text-amber-600 dark:text-amber-400 font-bold text-xs hover:bg-amber-50 dark:hover:bg-slate-700 border-none bg-transparent cursor-pointer rounded-r-xl">
            ค้นหา
          </button>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto h-[520px] relative custom-scrollbar" [class.opacity-50]="isLoading()">
      <table class="w-full text-left border-collapse min-w-[1100px]">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            <th class="p-5 w-[100px]">หลักฐาน</th>
            <th class="p-5">ชื่อส่วนลด</th>
            <th class="p-5">ทะเบียน</th>
            <th class="p-5">ประเภทรถ</th>
            <th class="p-5">เวลา stamp</th>
            <th class="p-5">ผู้ให้ส่วนลด</th>
            <th class="p-5 min-w-[200px]">หมายเหตุ</th>
            <th class="p-5 text-right w-[120px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200">
            <td class="p-5">
              <div *ngIf="item.pictureUrl"
                (click)="openImageModal(item.pictureUrl); $event.stopPropagation()"
                class="relative shrink-0 cursor-zoom-in group/img overflow-hidden rounded-xl w-20 h-[52px] bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 shadow-sm">
                <img [src]="item.pictureUrl"
                  class="w-full h-full object-cover transition-transform duration-500 group-hover/img:scale-110"
                  alt="หลักฐาน stamp"
                  (error)="$any($event.target).src='img/notfound.jpg'">
                <div class="absolute inset-0 bg-black/0 group-hover/img:bg-black/15 transition-all flex items-center justify-center">
                  <span class="material-icons text-white text-lg opacity-0 group-hover/img:opacity-100 drop-shadow">zoom_in</span>
                </div>
              </div>
              <div *ngIf="!item.pictureUrl"
                class="w-20 h-[52px] rounded-xl border border-dashed border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900/40 flex items-center justify-center text-slate-300 dark:text-slate-600">
                <span class="material-icons text-[18px]">image_not_supported</span>
              </div>
            </td>
            <td class="p-5">
              <div class="font-semibold text-slate-700 dark:text-slate-200 max-w-[180px]" [title]="item.rateName">
                {{ item.rateName || '—' }}
              </div>
              <div *ngIf="item.gateId" class="text-[11px] text-slate-400 mt-0.5 font-medium">Gate {{ item.gateId }}</div>
            </td>
            <td class="p-5">
              <span *ngIf="item.license"
                class="inline-flex items-center gap-1.5 pl-1.5 pr-3 py-1 rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-950/40 dark:to-orange-950/30 border border-amber-200/80 dark:border-amber-800/60 shadow-sm shadow-amber-100/50 dark:shadow-none">
                <span class="flex items-center justify-center w-7 h-7 rounded-lg bg-amber-400/90 text-white shadow-sm shadow-amber-300/40 dark:shadow-none">
                  <span class="material-icons text-[16px]">directions_car</span>
                </span>
                <span class="text-[15px] font-black tracking-wide text-slate-800 dark:text-amber-100 tabular-nums">
                  {{ item.license }}
                </span>
              </span>
              <span *ngIf="!item.license" class="text-slate-400">—</span>
            </td>
            <td class="p-5 text-slate-600 dark:text-slate-300">{{ item.vehicleTypeName || '—' }}</td>
            <td class="p-5 whitespace-nowrap">
              <div class="font-semibold text-slate-700 dark:text-slate-200 tabular-nums">{{ formatStampTime(item.stampTime) }}</div>
            </td>
            <td class="p-5">
              <div class="flex items-center gap-2 min-w-0">
                <span class="w-8 h-8 rounded-xl bg-slate-100 dark:bg-slate-700 flex items-center justify-center text-slate-400 shrink-0">
                  <span class="material-icons text-[16px]">person</span>
                </span>
                <span class="font-medium text-slate-700 dark:text-slate-200 truncate max-w-[140px]" [title]="item.userDisplayName">
                  {{ item.userDisplayName || '—' }}
                </span>
              </div>
            </td>
            <td class="p-5 max-w-[240px]">
              <p class="text-slate-500 dark:text-slate-400 leading-snug"
                [class.line-clamp-2]="!!item.remark?.trim()"
                [title]="item.remark">
                {{ remarkPreview(item.remark) }}
              </p>
              <button *ngIf="hasLongRemark(item.remark)" type="button" (click)="openDetail(item)"
                class="mt-1 text-[11px] font-bold text-amber-600 dark:text-amber-400 hover:underline border-none bg-transparent cursor-pointer p-0">
                อ่านทั้งหมด
              </button>
            </td>
            <td class="p-5 text-right">
              <button type="button" (click)="openDetail(item)" title="ดูรายละเอียด"
                class="inline-flex items-center gap-1.5 h-9 px-3 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 text-xs font-bold hover:border-amber-300 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50/60 dark:hover:bg-amber-900/20 transition-all cursor-pointer shadow-sm">
                <span class="material-icons text-[16px]">visibility</span>
                รายละเอียด
              </button>
            </td>
          </tr>

          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td colspan="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-50">location_city</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">กรุณาเลือกลานจาก Navbar</p>
              </div>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading() && items().length === 0">
            <td colspan="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-50">search_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">ไม่พบข้อมูล</p>
                <span class="text-sm mt-1">ลองเปลี่ยนช่วงวันที่ หรือเงื่อนไขค้นหา</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-3">
        <span class="text-xs font-semibold text-slate-500">
          แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems() }} รายการ
        </span>
        <div class="relative">
          <button type="button" (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm">
            <span>{{ pageSize() }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
          </button>
          <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full mb-2 left-0 w-full min-w-[100px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden">
            <button *ngFor="let size of pageSizeOptions" type="button" (click)="selectPageSize(size)"
              class="w-full text-left px-3 py-2 text-xs font-bold border-none bg-transparent cursor-pointer transition-colors"
              [ngClass]="size === pageSize()
                ? 'bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400'
                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700'">
              {{ size }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-1.5">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-500 hover:bg-slate-50 disabled:opacity-30 cursor-pointer transition-all">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" type="button" (click)="setPage(p)"
          class="w-8 h-8 flex items-center justify-center rounded-lg text-sm transition-all cursor-pointer border-none"
          [ngClass]="p === currentPage()
            ? 'bg-amber-400 text-slate-900 font-bold shadow-[0_4px_12px_rgba(251,191,36,0.35)]'
            : 'text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 bg-transparent'">
          {{ p }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-500 hover:bg-slate-50 disabled:opacity-30 cursor-pointer transition-all">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-web-stamp-history-detail
  *ngIf="showDetailModal() && selectedDetail() as detail"
  [item]="detail"
  (close)="closeDetail()"
  (openImage)="openImageModal($event)">
</app-modal-web-stamp-history-detail>

<!-- Image Zoom Modal -->
<div *ngIf="showImageModal"
  class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
  style="z-index: 99999 !important;" (click)="closeImageModal()">
  <button type="button"
    class="absolute top-4 right-4 text-white hover:text-amber-500 transition-colors z-[10000] border-none bg-transparent cursor-pointer"
    (click)="closeImageModal()">
    <span class="material-icons text-4xl">close</span>
  </button>
  <div class="relative max-w-[90vw] max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl"
    (click)="$event.stopPropagation()">
    <img [src]="selectedImageUrl" class="object-contain max-w-full max-h-[90vh]" alt="หลักฐาน stamp">
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
